module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAgCAYAAABU1PscAAAA1UlEQVRYR2OcrW15nus/w5AEr5j+32Rco2n5npmRUWAo+uALw7/tox4YyJgbjYGBDH2Q3aMxMBoDFIbA8EhC6+18zrH9+ctIYWAMiPbP3Bw3GH///v2ehYVlSNbEb9682T7qgQFJO1BLR2NgIEMfZPdoDIzGAIUhMJqEKAxAirWDY8Cnc9M5ZjaOIdmU+Pbh9Q1GhugZ7xmYmIdkU4Ll99ftox6gOCFTYMBoDFAQeFTROhoDVAlGCgwZjQEKAo8qWsExwB7Wff4vMwdVDKS3IVw/39wEAID/tiO9G4JzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/c143.png
// module id = /VxJ
// module chunks = 18